<template>
	<CreationWizardStepWrapper>
		<template #header>
			<FillToolDataHeader v-bind="$props" v-on="$listeners" />
		</template>
		<div class="display-flex flex-1 flex-wrap height-100">
			<div class="flex-col-12">
				<component :is="dataComponent" class="flex-1" ref="tool_data_component" @is-valid="setIsValid" />
			</div>
			<div class="flex-1 flex-center--end">
				<PrimaryButton @click="createTool" :disabled="!isValid" :loading="loading">Create</PrimaryButton>
			</div>
		</div>
	</CreationWizardStepWrapper>
</template>

<script>
import { FlowType, WorkflowAccessType } from '@ply-io/ply-front-shared-utilities';

import props from './FillToolData.props';
import FillToolDataHeader from './FillToolDataHeader.vue';
import { TOOL_PLACEMENTS } from '../ChooseToolPlacement/ChooseToolPlacement.const';
import WizardStepMixin from '../WizardStepMixin';
import { createAndSelectWorkflow } from '@/store/modules/selectedWorkflow/actions';
import { mapActionsShorthand } from '@/store/utils/mappers';

export default {
	name: 'FillToolData',
	mixins: [WizardStepMixin],
	props,
	components: { FillToolDataHeader },
	computed: {
		dataComponent() {
			return TOOL_PLACEMENTS[this.selectedToolPlacementId].dataComponent;
		},
		toolPlacementEnabled() {
			return TOOL_PLACEMENTS[this.selectedToolPlacementId].toolPlacementFlag;
		},
	},
	methods: {
		...mapActionsShorthand({ createAndSelectWorkflow }),
		createTool() {
			const toolPlacementData = this.$refs.tool_data_component.getToolPlacementData();
			this.create(toolPlacementData);
		},
		setIsValid(valid) {
			// comes from `tool_data_component`, as it knows the true state of the required data
			this.isValid = valid;
		},
		async create(payload) {
			const toolPreferences = { main_placement: this.selectedToolPlacementId, [this.toolPlacementEnabled]: true };
			if (payload.command) {
				toolPreferences.command_bar_title = payload.command;
				toolPreferences.command_bar_created_in_url = this.currentUrl;
			}
			const workflow = {
				workflow_title: payload.name,
				flow_type: FlowType.Tool,
				access_type: WorkflowAccessType.SharedUsersOnly,
				project: this.selectedProjectId,
				tool_preferences: toolPreferences,
			};
			if (payload.icon) {
				workflow.icon_name = payload.icon;
			}
			this.loading = true;
			try {
				// This will auto redirect to the new created flow!
				this.closeWizard();
				const newWorkflow = await this.createAndSelectWorkflow({ workflow });
				this.workflowCreated(newWorkflow);
			} catch (err) {
				this.$toast.error('Error occurred while creating new flow');
				console.error(err);
			} finally {
				this.loading = false;
			}
		},
	},
	data() {
		return { isValid: false, loading: false };
	},
};
</script>

<style scoped lang="scss"></style>
